import React from 'react';
import { ImageLogo } from '../../../assets/images';
import { OutlineButton } from '../../../components/Buttons';

function AboutHome(props) {
  return (
    <div id="AboutHome" className="offset">
      <div className="about-home-description">
        <h1>Who are we</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae totam, asperiores facilis et saepe placeat vel cum impedit necessitatibus labore nostrum tenetur veritatis architecto minus, alias optio temporibus amet obcaecati!</p>
        <div className="logo">
          <img src={ImageLogo} alt="logo-about" />
        </div>
      </div>
      <div className="about-home-action">
        <OutlineButton
          title={"Try to find out about us"}
        />
      </div>
    </div>
  );
}

export default AboutHome;